import { createAction, props } from "@ngrx/store";

export const forgotPassword = createAction("[Auth] forgotPassword", props<{ email: string; }>());
export const forgotPasswordComplete = createAction("[Auth] forgotPasswordComplete");
export const forgotPasswordFailure = createAction("[Auth] forgotPasswordFailure", props<{ error: any }>());
export const clearState = createAction("[Auth] clearState");